import React from "react";
import { useNavigate } from "react-router-dom";

const FaceLiveness = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="grid md:grid-cols-3 grid-cols-1 p-10 h-screen place-items-center">
        <button
          onClick={() => navigate(-1)} // Goes back to the previous page
          className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition"
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default FaceLiveness;
